import { addDoc, deleteDoc, doc, getDoc, getDocs, query, updateDoc, where } from 'firebase/firestore';
import { DistributionCenter, distributionCentersRef } from '@api/DistributionCenters/DistributionCenter';
import { BranchOffice, branchOfficesRef } from '@api/BranchOffices/BranchOffice';

export default {
    async saveDistributionCenter(distributionCenter: DistributionCenter): Promise<DistributionCenter> {
        if (!distributionCenter.id) {
            const data = await addDoc(distributionCentersRef, distributionCenter);
            distributionCenter.id = data.id;
        }
        await updateDoc(doc(distributionCentersRef, distributionCenter.id), { ...distributionCenter });
        return distributionCenter;
    },
    async getDistributionCenters(): Promise<DistributionCenter[]> {
        const distributionCenters: DistributionCenter[] = [];
        const queryDoc = query(distributionCentersRef);
        const snapshot = await getDocs(queryDoc);
        if (snapshot.empty) {
            return distributionCenters;
        }
        snapshot.docs.map((doc: any) => {
            distributionCenters.push(doc.data() as DistributionCenter);
        });
        return distributionCenters;
    },
    async getDistributionCenter(distributionCenterId: string): Promise<DistributionCenter> {
        const documentData = await getDoc(doc(distributionCentersRef, distributionCenterId));
        return documentData.data() as DistributionCenter;
    },
    async getDistributionCenterByManagerId(managerId: string): Promise<DistributionCenter | undefined> {
        let distributionCenter = undefined;
        const queryDoc = query(distributionCentersRef, where('managerId', '==', managerId));
        const snapshot = await getDocs(queryDoc);
        if (snapshot.empty) {
            return distributionCenter;
        }
        snapshot.forEach((doc: any) => {
            distributionCenter = doc.data() as DistributionCenter;
        });
        return distributionCenter;
    },
    async deleteDistributionCenter(distributionCenterId: string): Promise<void> {
        await deleteDoc(doc(distributionCentersRef, distributionCenterId));
        return;
    },
    async toggleStatus(distributionCenterId: string): Promise<void> {
        const distributionCenter = await this.getDistributionCenter(distributionCenterId);
        await updateDoc(doc(distributionCentersRef, distributionCenterId), { status: !distributionCenter.status });
        return;
    },
    async getBranchOffices(distributionCenterId: string): Promise<BranchOffice[]> {
        const branchOffices: BranchOffice[] = [];
        const queryBranchOfficesDoc = query(
            branchOfficesRef,
            where('distributionCenterId', '==', distributionCenterId)
        );
        const snapshot = await getDocs(queryBranchOfficesDoc);
        if (snapshot.empty) {
            return branchOffices;
        }
        snapshot.docs.map((doc: any) => {
            branchOffices.push(doc.data() as BranchOffice);
        });
        return branchOffices;
    }
};
